import { render, staticRenderFns } from "./kindChooseViewsixthzl.vue?vue&type=template&id=50425d95&scoped=true"
import script from "./kindChooseViewsixthzl.vue?vue&type=script&lang=js"
export * from "./kindChooseViewsixthzl.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewsixthzl.vue?vue&type=style&index=0&id=50425d95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50425d95",
  null
  
)

export default component.exports